import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { LocalStorage } from '@core/localstorage';
import { NbWindowRef, NbWindowService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { SharedH2hComponent } from 'src/app/@theme/components/shared-h2h/shared-h2h.component';

@Component({
    selector: 'app-games-bracket',
    templateUrl: './games-bracket.component.html',
    styleUrls: ['./games-bracket.component.scss'],
})
export class GamesBracketComponent implements OnInit {
    @Input() games: any;
    @Input() windowRef: NbWindowRef;
    @ViewChild('container') container: ElementRef<HTMLElement>;
    gamesDivided = [];

    headers = [];

    destroy$: Subject<any> = new Subject();

    tabsView: boolean = true;

    window: NbWindowRef;

    activeView: any;

    pos = { top: 0, left: 0, x: 0, y: 0 };

    mouseMoveBound;
    mouseUpBound;

    constructor(
        private nbWindowService: NbWindowService,
        @Inject(DOCUMENT) private document: Document,
        private localStorage: LocalStorage
    ) {}

    ngOnInit(): void {
        this.headers = this.games.reduce(
            (acc, cur) => (acc = [...acc, { titulo_sub_caixa: cur.titulo_sub_caixa }]),
            []
        );
        this.activeView = this.headers[0];
        this.gamesDivided = this.getPhasesToShow(this.activeView.titulo_sub_caixa);

        console.log(this.games);
    }
    mouseDownHandler(e) {
        const body = this.container.nativeElement.parentElement.parentElement.parentElement;

        body.style.cursor = 'grabbing';
        body.style.userSelect = 'none';

        this.pos = {
            left: body.scrollLeft,
            top: body.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };

        if (!this.mouseMoveBound) {
            this.mouseMoveBound = this.mouseMoveHandler.bind(this);
        }
        if (!this.mouseUpBound) {
            this.mouseUpBound = this.mouseUpHandler.bind(this);
        }

        this.document.addEventListener('mousemove', this.mouseMoveBound);
        this.document.addEventListener('mouseup', this.mouseUpBound);
    }
    mouseMoveHandler(e) {
        const body = this.container.nativeElement.parentElement.parentElement.parentElement;

        // How far the mouse has been moved
        const dx = e.clientX - this.pos.x;
        const dy = e.clientY - this.pos.y;

        // Scroll the element
        body.scrollTop = this.pos.top - dy;
        body.scrollLeft = this.pos.left - dx;
    }
    mouseUpHandler() {
        const body = this.container.nativeElement.parentElement.parentElement.parentElement;
        body.style.cursor = 'grab';
        body.style.removeProperty('user-select');

        this.document.removeEventListener('mousemove', this.mouseMoveBound);
        this.document.removeEventListener('mouseup', this.mouseUpBound);
    }
    // ngAfterViewChecked() {
    //     if (this.windowRef) {
    //         //console.log(this.windowRef);
    //     }
    // }

    ngAfterViewInit() {
        // this.windowRef.stateChange.subscribe((state) => {
        //     //console.log(state);
        // });
        setTimeout(() => {
            if (this.windowRef) {
                this.windowRef.stateChange.subscribe(({ oldState, newState }) => {
                    if (newState === 'full-screen') {
                        this.gamesDivided = this.games;

                        this.tabsView = false;
                    }
                    if (newState === 'maximized') {
                        this.tabsView = true;
                    }
                });
            }
        }, 0);
    }

    initialPhases(phaseTitle) {
        phaseTitle = phaseTitle.toLowerCase();
        return phaseTitle !== 'finais' && phaseTitle !== 'semi';
    }

    getPhasesToShow(phaseHeader) {
        const phaseIndex = this.games.findIndex((phase) => phase.titulo_sub_caixa === phaseHeader);

        if (phaseHeader.toLowerCase() === 'finais') return this.games.slice(phaseIndex - 1, phaseIndex + 2);

        return this.games.slice(phaseIndex, phaseIndex + 2);
    }

    onTabChange(event) {
        this.gamesDivided = this.getPhasesToShow(event.tabTitle);
    }

    cupBodyClass(phaseHeader) {
        return ['cup-body', phaseHeader.titulo_sub_caixa.replace(/ /g, '-').toLowerCase()];
    }

    roundFullSizeClass(phaseHeader) {
        return ['round', phaseHeader.titulo_sub_caixa.replace(/[^A-Z0-9]+/gi, '-').toLowerCase()];
    }

    openMatchDetails(game) {
        if (game.jogo_com_bye) return;
        this.window = this.nbWindowService.open(SharedH2hComponent, {
            title: game?.sub_jogos?.length > 0 ? 'Confrontos do jogo' : 'Estatísticas do Jogo',
            context: game,
            windowClass: 'no-extra-buttons',
        });
    }

    previousPhase() {
        const activeIndex = this.headers.findIndex((h) => h.titulo_sub_caixa === this.activeView.titulo_sub_caixa);
        const previousIndex = activeIndex - 1 === -1 ? this.headers.length - 1 : activeIndex - 1;

        this.activeView = this.headers[previousIndex];
        this.gamesDivided = this.getPhasesToShow(this.activeView.titulo_sub_caixa);
    }

    nextPhase() {
        const activeIndex = this.headers.findIndex((h) => h.titulo_sub_caixa === this.activeView.titulo_sub_caixa);
        const nextIndex = activeIndex + 1 === this.headers.length ? 0 : activeIndex + 1;

        this.activeView = this.headers[nextIndex];
        this.gamesDivided = this.getPhasesToShow(this.activeView.titulo_sub_caixa);
    }

    showInfo() {
        return (
            this.localStorage.isBrazil() &&
            this.gamesDivided?.some((phase) => phase.dados_sub_caixa?.some((game) => game.sub_jogos?.length > 0))
        );
    }
}
